import { useEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

/**
 * Scroll to the top of the page on route navigation. Mounted once
 * inside <Router> in App.tsx.
 *
 * SPA routing preserves the document, so scroll position carries
 * across navigations — clicking "Tiers" from the bottom of the
 * front page would land you at the bottom of /tiers, near the FAQ,
 * which is not the user's expectation.
 *
 * Two cases we *don't* want to override:
 *   - Browser back/forward (navigationType === 'POP'): the browser
 *     restores scroll position on its own; resetting to top here
 *     would feel broken.
 *   - URL hash navigation (#swap, #safety-details, etc): the page
 *     wants the browser to scroll to that anchor.
 */
export const ScrollToTop: React.FC = () => {
  const { pathname, hash } = useLocation();
  const navType = useNavigationType();
  useEffect(() => {
    if (navType === 'POP') return;
    if (hash) return;
    window.scrollTo(0, 0);
  }, [pathname, hash, navType]);
  return null;
};
